import { Copy, Terminal, Github, CheckCircle2 } from 'lucide-react';
import { useState } from 'react';

export function IntegrationsPage() {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    const code = `{
  "mcpServers": {
    "eric-mec": {
      "type": "http",
      "url": "https://mec.ericai.online/mcp",
      "headers": {
        "Authorization": "Bearer eric_mec_***abc"
      }
    }
  }
}`;
    navigator.clipboard.writeText(code);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const handleConfigure = () => {
    alert("GitHub integration module is opening...");
  };

  const handleConnectAnother = () => {
    const repo = prompt("Enter your GitHub repository URL:");
    if (repo) {
      alert(`Connecting to ${repo}... Webhook configured!`);
    }
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: '32px', maxWidth: '800px', margin: '0 auto' }}>
      
      <div>
        <h2 style={{ fontSize: '24px', fontWeight: 600, marginBottom: '8px' }}>Integrations & Setup</h2>
        <p style={{ color: 'var(--text-secondary)' }}>Connect your AI agents to Eric MEC and automate knowledge ingestion.</p>
      </div>

      {/* MCP Configuration */}
      <div className="glass-panel" style={{ padding: '32px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
          <div className="glow-box" style={{ background: 'var(--bg-surface)', padding: '12px', borderRadius: '12px' }}>
            <Terminal size={32} color="var(--accent-cyan)" />
          </div>
          <div>
            <h3 style={{ fontSize: '20px', fontWeight: 600 }}>MCP Connection Wizard</h3>
            <p style={{ color: 'var(--text-secondary)', fontSize: '14px' }}>Inject memory into Claude Code, Cursor, or Continue.dev</p>
          </div>
        </div>

        <div style={{ background: '#000', padding: '24px', borderRadius: '12px', border: '1px solid var(--border)', position: 'relative' }}>
          <div style={{ color: 'var(--text-muted)', fontSize: '12px', marginBottom: '12px', fontFamily: 'var(--font-mono)' }}>~/.claude/settings.json</div>
          <pre style={{ margin: 0, fontFamily: 'var(--font-mono)', fontSize: '13px', color: '#e2e8f0', overflowX: 'auto', lineHeight: 1.6 }}>
<span style={{ color: '#8b5cf6' }}>{`{`}</span>
  <span style={{ color: '#2dd4bf' }}>"mcpServers"</span>: <span style={{ color: '#8b5cf6' }}>{`{`}</span>
    <span style={{ color: '#2dd4bf' }}>"eric-mec"</span>: <span style={{ color: '#8b5cf6' }}>{`{`}</span>
      <span style={{ color: '#2dd4bf' }}>"type"</span>: <span style={{ color: '#fcd34d' }}>"http"</span>,
      <span style={{ color: '#2dd4bf' }}>"url"</span>: <span style={{ color: '#fcd34d' }}>"https://mec.ericai.online/mcp"</span>,
      <span style={{ color: '#2dd4bf' }}>"headers"</span>: <span style={{ color: '#8b5cf6' }}>{`{`}</span>
        <span style={{ color: '#2dd4bf' }}>"Authorization"</span>: <span style={{ color: '#fcd34d' }}>"Bearer eric_mec_***abc"</span>
      <span style={{ color: '#8b5cf6' }}>{`}`}</span>
    <span style={{ color: '#8b5cf6' }}>{`}`}</span>
  <span style={{ color: '#8b5cf6' }}>{`}`}</span>
<span style={{ color: '#8b5cf6' }}>{`}`}</span>
          </pre>
          <button onClick={handleCopy} className="btn btn-primary" style={{ position: 'absolute', top: '24px', right: '24px', background: copied ? 'var(--accent-green)' : '' }}>
            <Copy size={16} /> {copied ? 'Copied!' : 'Copy Snippet'}
          </button>
        </div>

        <div style={{ display: 'flex', gap: '16px', marginTop: '24px' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', color: 'var(--text-secondary)' }}>
            <CheckCircle2 size={16} color="var(--accent-green)" /> Supports stdio
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', color: 'var(--text-secondary)' }}>
            <CheckCircle2 size={16} color="var(--accent-green)" /> Supports SSE
          </div>
          <div style={{ display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', color: 'var(--text-secondary)' }}>
            <CheckCircle2 size={16} color="var(--accent-green)" /> 5 Standard Tools mapped
          </div>
        </div>
      </div>

      {/* Auto Ingestion */}
      <div className="glass-panel" style={{ padding: '32px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
          <div style={{ background: 'var(--bg-surface)', padding: '12px', borderRadius: '12px', border: '1px solid var(--border)' }}>
            <Github size={32} color="var(--text-primary)" />
          </div>
          <div>
            <h3 style={{ fontSize: '20px', fontWeight: 600 }}>Auto-Ingestion (GitHub)</h3>
            <p style={{ color: 'var(--text-secondary)', fontSize: '14px' }}>Automatically re-index your codebase on every push.</p>
          </div>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', background: 'rgba(255,255,255,0.02)', padding: '16px 24px', borderRadius: '8px', border: '1px dashed var(--border-accent)' }}>
          <div>
            <div style={{ fontWeight: 500, fontSize: '15px' }}>eric-ai/eric-context-memory</div>
            <div style={{ color: 'var(--accent-green)', fontSize: '13px', marginTop: '4px' }}>Connected & Active</div>
          </div>
          <button onClick={handleConfigure} className="btn btn-glass">Configure</button>
        </div>

        <button onClick={handleConnectAnother} className="btn btn-primary" style={{ marginTop: '16px', width: '100%' }}>
          Connect another Repository
        </button>
      </div>

    </div>
  );
}
